import { Box, Container, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllSchoolAsync } from './FeaturedSchoolStore/FeaturedSchoolSlice';
import { toast } from 'react-toastify';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import { Column } from './columns';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';

const useStyles = makeStyles((theme) => ({
  overAll: {
    maxWidth: 1452,
    backgroundColor: theme.palette.buzzContainerColor,
    borderRadius: 4,
    paddingLeft: 44,
    paddingRight: 44,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 60,
    fontFamily: 'Rubik',
  },
  premiumModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

function FeaturedSchoolScreen() {
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const [name, setName] = useState('');
  const [status, setStatus] = useState('');
  const dispatch = useDispatch();

  const { schools } = useSelector(({ FeaturedSchoolReducer }) => {
    return {
      schools: FeaturedSchoolReducer && FeaturedSchoolReducer.schools,
    };
  });

  const fetchData = async () => {
    try {
      dispatch(getAllSchoolAsync({}))
        .unwrap()
        .then((res) => {
          toast.success('All Schools were fetched successfully!');
        });
    } catch (error) {
      toast.error('Schools could not be fetched. Please try again!');
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getAllSchoolAsync({
          params: {
            page: val,
            limit: 10,
            featured:
              status === 'nonFeatured'
                ? false
                : status === 'featured'
                ? true
                : null,
          },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All Schools were fetched successfully!');
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };

  const handleSearchUser = () => {
    dispatch(
      getAllSchoolAsync(
        name.match(/^\d/)
          ? {
              params: {
                schoolId: name,
              },
            }
          : {
              params: {
                name: name,
              },
            }
      )
    )
      .unwrap()
      .then((res) => {
        // toast.success('All Offer Details fetched successfully.');
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const handleStatus = (value) => {
    setStatus(value === 'nonFeatured' ? 'nonFeatured' : 'featured');
    dispatch(
      getAllSchoolAsync({
        params: {
          featured: value === 'nonFeatured' ? false : true,
        },
      })
    )
      .unwrap()
      .then((res) => {
        // toast.success('All Offer Details fetched successfully.');
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <Container className={classes.overAll}>
      <Box display={'flex'} pt={4}>
        <BuzzInput
          size="small"
          placeholder="Search by school name or schoolId"
          search
          value={name}
          onChange={(e) => setName(e.target.value)}
          onSubmitEditing={handleSearchUser}
        />
        <Box width={220} pl={80}>
          <BuzzSelect
            labelKey="label"
            valueKey="value"
            options={[
              { label: 'Featured School', value: 'featured' },
              { label: 'Non Featured School', value: 'nonFeatured' },
            ]}
            placeholder="Select"
            value={status}
            onChange={(e) => handleStatus(e.target.value)}
            size="small"
          />
        </Box>
      </Box>

      <Box my={4}>
        <BuzzTable columns={Column} data={schools && schools.data} />
      </Box>
      <Box display="flex" justifyContent="center" mb={2}>
        <BuzzPagination
          onClick={handlePageChange}
          total={schools && schools.count}
          pageNo={page}
          defaultPage={1}
          perPage={10}
        />
      </Box>
    </Container>
  );
}

export default FeaturedSchoolScreen;
